import React, { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
} from "reactstrap";
import CustomerForm from "./CustomerForm";
import CustomerServices from "../../../../../services/OrderingServices/CustomerServices";

const CustomerList = ({
  isOpen,
  toggle,
  selectedCustomer,
  setSelectedCustomer,
}) => {
  const [searchedText, setSearchedText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recentCustomers, setRecentCustomers] = useState([]);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await CustomerServices.getCustomerList();

      setRecentCustomers(response);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchCustomers();
  }, []);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  // Filter customers
  const filteredCustomers = useMemo(() => {
    if (!searchedText.trim()) return recentCustomers;

    const lowerSearch = searchedText.toLowerCase();
    return recentCustomers.filter(
      (customer) =>
        customer.firstName.toLowerCase().includes(lowerSearch) ||
        customer.phoneNo.includes(lowerSearch)
    );
  }, [searchedText, recentCustomers]);
  useEffect(() => {
    const storedCustomer = localStorage.getItem("selectedCustomer");
    if (storedCustomer) {
      setSelectedCustomer(JSON.parse(storedCustomer));
    }
  }, []);

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      backdropClassName="bg-dark bg-opacity-50"
      className="shadow-lg animate__animated animate__slideInRight bg-white rounded-start"
      // id="offcanvasRight"
    >
      <OffcanvasHeader className="d-block d-sm-none">
        <div className="d-flex justify-content-between align-items-center w-100 rounded-top">
          <button className="btn btn-sm btn-light" onClick={toggle}>
            <i class="bx bx-chevron-left"></i>
          </button>
          <div className="d-flex align-items-center text-center justify-content-center w-100 gap-2">
            <i className="ri-stack-line"></i>
            <h5 className="mb-0">Customer List</h5>
          </div>
        </div>
      </OffcanvasHeader>
      <div
        className="position-absolute d-none d-sm-block"
        style={{ left: "-40px", top: "10px" }}
      >
        <button className="btn btn-sm btn-light" onClick={toggle}>
          <i className="ri-close-line"></i>
        </button>
      </div>
      {/* Desktop Header */}
      <div className="d-none d-sm-flex justify-content-start align-items-center p-3 shadow-sm rounded-top">
        <i className="ri-stack-line"></i>
        <h5 className="mb-0 ms-2">Customer List</h5>
      </div>
      <div
        className="d-flex gap-4 sticky-top bg-white pb-3 z-3 w-100 px-4"
        style={{ top: 0 }}
      >
        <div className="position-relative w-100">
          <i className="ri-search-line position-absolute top-50 translate-middle-y start-0 ms-3 text-muted fs-5"></i>
          <Input
            type="text"
            placeholder="Search recent customers..."
            value={searchedText}
            onChange={(e) => setSearchedText(e.target.value)}
            className="ps-5 py-2 rounded-pill border-0 bg-light text-dark"
            style={{
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              fontSize: "14px",
            }}
          />
          {searchedText && (
            <i
              className="ri-close-line position-absolute top-50 translate-middle-y end-0 me-3 text-danger cursor-pointer fs-5"
              onClick={() => setSearchedText("")}
            />
          )}
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <i
            className="ri-user-add-line fs-5 cursor-pointer"
            onClick={toggleModal}
          ></i>
        </div>
      </div>
      <OffcanvasBody className="p-4 pt-2 ">
        {/* Search + Add */}

        {/* Customers List */}
        {/* <div className="pt-2">
          <h6>Recent Customers</h6>
          {filteredCustomers.length > 0 ? (
            filteredCustomers.map((customer, index) => (
              <Card
                key={index}
                onClick={() =>
                  setSelectedCustomer(
                    selectedCustomer?.id === customer.id ? null : customer
                  )
                }
                className={`mb-3 position-relative shadow-sm rounded-4 cursor-pointer ${
                  selectedCustomer?.id === customer.id
                    ? "border border-success"
                    : "border-0"
                }`}
                style={{
                  transition: "transform 0.2s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.01)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <CardBody className="d-flex justify-content-between align-items-center py-3 px-4">
                  <div className="d-flex flex-column">
                    <h6 className="mb-1 fw-bold text-dark">
                      {customer.firstName} {customer?.lastName}
                    </h6>
                    <small className="text-muted">{customer.phoneNo}</small>
                  </div>
                  <div className="text-end">
                    <span className="badge bg-light text-dark d-block mb-1">
                      {customer.table}
                    </span>
                    <span
                      className={`badge ${
                        customer.status === "Completed"
                          ? "bg-success"
                          : customer.status === "Pending"
                          ? "bg-warning text-dark"
                          : "bg-info"
                      }`}
                    >
                      {customer.status}
                    </span>
                  </div>
                </CardBody>
              </Card>
            ))
          ) : (
            <div className="text-center text-muted mt-4">
              No customers found.
            </div>
          )}
        </div>

        {selectedCustomer && (
          <div className="mt-3 small text-secondary">
            Selected: <strong>{selectedCustomer.firstName}</strong> (
            {selectedCustomer.phoneNo})
          </div>
        )} */}
      </OffcanvasBody>
      <div className="border-0 p-3">
        <Button
          color="success"
          disabled={!selectedCustomer}
          onClick={() => {
            localStorage.setItem(
              "selectedCustomer",
              JSON.stringify(selectedCustomer)
            );
            toggle(); // Close the modal
          }}
          className=" px-4 w-100"
        >
          Confirm
        </Button>
      </div>

      {/* Form modal */}
      <CustomerForm
        isOpen={isModalOpen}
        toggle={toggleModal}
        // onSave={handleAddCustomer}
        fetchCustomers={fetchCustomers}
      />
    </Offcanvas>
  );
};

export default CustomerList;
